<template>
  <div class="warper clearfix">
    <div style="height: 68px"></div>
    <div class="ArticleListBox">
      <a-row type="flex" justify="space-between">
        <a-col :span="5">
          <div class="cateBox">
            <div class="searchBox">
              <a-dropdown :trigger="['click', 'change']">
                <a-input-search
                  v-model:value="Searchvalue"
                  placeholder="search documents"
                  @search="onSearch"
                  @change="onChange"
                />
              </a-dropdown>
            </div>
            <div v-if="List.length > 0" style="display: relative">
              <a-menu
                class="Amenu"
                :openKeys="openKeys"
                v-model:selectedKeys="selectedKeys"
                mode="inline"
                :inlineIndent="20"
                @openChange="openChange"
              >
                <a-sub-menu v-for="first in List" :key="first.id">
                  <template slot="expandIcon"></template>
                  <template slot="title">
                    <i
                      :class="[
                        openKeys.includes(first.id)
                          ? 'iconfont icon-down'
                          : 'iconfont icon-right',
                      ]"
                    ></i>
                    {{ first.name }}
                  </template>
                  <template v-for="second in first.children">
                    <a-menu-item
                      v-if="second.children.length == 0"
                      :key="second.id"
                      @click="selectNode(second, second.children[0])"
                    >
                      <span
                        class="disable"
                        v-if="second.flag == 'disable'"
                        :title="second.name"
                        >- {{ second.name }}</span
                      >
                      <span :title="second.name" v-else
                        >- {{ second.name }}</span
                      >
                    </a-menu-item>
                    <a-menu-item
                      v-else-if="second.children.length == 1"
                      :key="second.children[0].id"
                      @click="selectNode(second.children[0])"
                    >
                      <span
                        class="disable"
                        v-if="second.flag == 'disable'"
                        :title="second.name"
                        >- {{ second.name }}</span
                      >
                      <span :title="second.name" v-else
                        >- {{ second.name }}</span
                      >
                    </a-menu-item>
                    <a-sub-menu v-else :key="second.id">
                      <template slot="title">
                        <i
                          :class="[
                            openKeys.includes(second.id)
                              ? 'iconfont icon-down'
                              : 'iconfont icon-right',
                          ]"
                        ></i>
                        {{ second.name }}
                      </template>
                      <template v-for="third in second.children">
                        <a-menu-item
                          v-if="third.children.length == 0"
                          :key="third.id"
                          @click="selectNode(third)"
                        >
                          <span
                            class="disable"
                            v-if="third.flag == 'disable'"
                            :title="third.name"
                            >- {{ third.name }}</span
                          >
                          <span :title="third.name" v-else
                            >- {{ third.name }}</span
                          >
                        </a-menu-item>
                        <a-menu-item
                          v-else-if="third.children.length == 1"
                          :key="third.children[0].id"
                          @click="selectNode(third, third.children[0])"
                        >
                          <span
                            class="disable"
                            v-if="third.flag == 'disable'"
                            :title="third.name"
                            >- {{ third.name }}</span
                          >
                          <span :title="third.name" v-else
                            >- {{ third.name }}</span
                          >
                        </a-menu-item>
                        <a-sub-menu v-else :key="third.id">
                          <template slot="title">
                            <i
                              :class="[
                                openKeys.includes(third.id)
                                  ? 'iconfont icon-down'
                                  : 'iconfont icon-right',
                              ]"
                            ></i>
                            {{ third.name }}
                          </template>
                          <a-menu-item
                            v-for="arti in third.children"
                            :key="arti.id"
                            @click="selectNode(arti)"
                          >
                            <span
                              class="disable"
                              v-if="arti.flag == 'disable'"
                              :title="arti.name"
                              >- {{ arti.name }}</span
                            >
                            <span :title="arti.name" v-else
                              >- {{ arti.name }}</span
                            >
                          </a-menu-item>
                        </a-sub-menu>
                      </template>
                    </a-sub-menu>
                  </template>
                </a-sub-menu>
              </a-menu>
            </div>
          </div>
        </a-col>

        <a-col :span="19">
          <div class="breadcrumbBox">
            <!-- 面包屑 -->
            <a-breadcrumb>
              <a-breadcrumb-item>
                <i
                  class="iconfont icon-menu-home"
                  style="color: var(--theme-color); margin-right: 5px"
                ></i>
                <a :href="homeHref" @click.prevent="goHome" class="hoverColor" style="color: var(--theme-color)"
                  >Help Center</a
                ></a-breadcrumb-item
              >
              <a-breadcrumb-item v-for="item in TreeNames" :key="item">
                <span style="color: var(--theme-color)"> {{ item }}</span>
              </a-breadcrumb-item>
            </a-breadcrumb>
          </div>
          <div v-if="showArticleContent">
            <ArticleContent :id="articleId" :title="articleTitle" />
          </div>
          <div v-else>
            <div style="min-height: 80vh">
              <div style="padding-left: 1rem; margin-bottom: 1rem">
                <span style="color: var(--theme-color); font-weight: 600"
                  >“{{ SearchvalueKey }}”</span
                >Search result:
                <span style="color: var(--theme-color); font-weight: 600">{{
                  searchList.length
                }}</span>
              </div>
              <div
                class="ListBox"
                v-for="(item, index) in searchList"
                :key="index"
                @click="selectNode(item)"
              >
                <div class="title">{{ item.docTitle }}</div>
                <div>
                  <span v-html="item.highlightContent"></span>
                  <span style="color: var(--theme-color); margin-left: 8px">More</span>
                </div>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import ArticleContent from "@/views/ArticleContent.vue";
import { categories, getIspCategories, queryArticleList, queryIspArticleList } from "@/utils/query.js";
import { getTreeIds, getTreeNames, getTreeTitle } from "@/utils/tool.js";

export default {
  components: {
    ArticleContent,
  },
  data() {
    return {
      Searchvalue: "",
      SearchvalueKey: "",
      openKeys: [],
      selectedKeys: [],
      replaceFields: {
        title: "name",
        key: "id",
      },
      List: [],
      breadItem: {},
      articleId: "",
      articleTitle: "",
      TreeNames: [], //被选中文章的父级目录们
      showArticleContent: true,
      searchList: [],
    };
  },
  mounted() {
    this.getCate();
    console.log(this.TreeNames);
  },
  computed: {
    isIsp() {
     return sessionStorage.getItem("isIsp") === "true"
    },

    homeHref() {
      const route = this.$router.resolve({ path: this.isIsp ? "/isp" : "/" });
      return route.href;
    },
  },
  activated() {
    this.initData();
  },
  methods: {
    goHome() {
      const targetPath = this.isIsp ? "/isp" : "/";
      if (this.$route.path !== targetPath) {
        this.$router.push(targetPath);
      }
    },
    async getCate() {
      let res = null;
      if (this.isIsp) {
        res = await getIspCategories();
      } else {
        res = await categories();
      }
      this.List = [];
      if (res.code == "200") {
        this.List = res.data.directoryJson;
      }
      this.initData();
    },
    initData() {
      this.showArticleContent = true;
      let { id, SearchValue } = this.$route.query;
      if (SearchValue) {
        this.Searchvalue = SearchValue;
        this.onSearch();
        this.articleId = "";
        this.selectedKeys = [];
        this.openKeys = [];
        this.TreeNames = [];
      } else {
        this.articleId = id;
        this.selectedKeys = [id];
        this.openKeys = getTreeIds(this.List, id);
        this.TreeNames = getTreeNames(this.List, id);
        this.sentzhugePoint();
      }
    },
    selectNode(item, firstChild = {}) {
      this.articleId = item.id || String(item.g_id).split("&")[0];
      // this.articleTitle = item.name;
      if (firstChild.id) {
        this.articleId = firstChild.id;
        // this.articleTitle = firstChild.name;
      }
      let title = item.title || item.docTitle;
      if (title.includes("Release Notes")) {
        this.$router.push({
          name: "releaseArticle",
          query: { id },
        });
      } else {
        this.$router.push({
          name: "ArticleList",
          query: { id: this.articleId },
        });
      }
      this.initData();
    },
    // searchListClick() {
    //   this.selectedKeys = [this.articleId];
    //   this.openKeys = getTreeIds(this.List, this.articleId);
    //   this.TreeNames = getTreeNames(this.List, this.articleId);
    //   this.sentzhugePoint();
    // },
    openChange(openKeys) {
      this.openKeys = openKeys;
    },
    async onSearch() {
      if (this.Searchvalue == "") return;
      this.showArticleContent = false;
      let res = null;
      if (this.isIsp) {
        res = await queryIspArticleList(this.Searchvalue);
      } else {
        res = await queryArticleList(this.Searchvalue);
      }
      let { items } = res.data.result;
      if (res.success) {
        this.searchList = [...items];
      } else {
        this.searchList = [];
      }
      this.SearchvalueKey = this.Searchvalue;
      console.log("searchList", this.searchList);
    },
    async onChange() {
      this.SearchvalueKey = this.Searchvalue;
      if (this.Searchvalue == "") {
        this.searchList = [];
        return;
      }
      this.showArticleContent = false;
      this.searchList = [];
      let res = null;
      if (this.isIsp) {
        res = await queryIspArticleList(this.Searchvalue);
      } else {
        res = await queryArticleList(this.Searchvalue);
      }
      let { items } = res.data.result;
      if (res.success) {
        this.searchList = [...items];
      }
    },
    sentzhugePoint() {
      let lv01 = this.TreeNames[0];
      let lv02 = this.TreeNames[1] ? this.TreeNames[1] : "";
      let lv03 = this.TreeNames[2] ? this.TreeNames[2] : "";
      this.zhugePoint("macc-help-文档中心-模块统计", {
        userid: this.GLOBAL.userid, //用户id
        lv01, //一级目录、模块
        lv02, //二级目录
        lv03, //三级目录
      });
      console.log("macc-help-文档中心-模块统计", this.TreeNames);
    },
  },
};
</script>
<style scoped>
::v-deep .ant-breadcrumb-separator {
  color: var(--theme-color);
}

.ArticleListBox {
  padding-top: 1rem;
  /* margin-top: 68px; */
}

.cateBox {
  width: 240px;
  position: fixed;
  margin-top: 1rem;
  border-radius: 5px;
  background-color: var(--bg-page);
}
.searchBox {
  padding: 1rem;
  z-index: 999;
  background-color: var(--bg-page);
}

/* .Amenu::-webkit-scrollbar{ */
.Amenu::-webkit-scrollbar {
  width: 5px;
}
.Amenu::-webkit-scrollbar-track {
  background: var(--gray-4);
  border-radius: 5px;
}
.Amenu::-webkit-scrollbar-thumb {
  background: var(--gray-6);
  border-radius: 5px;
}
.Amenu::-webkit-scrollbar-thumb:hover {
  background: var(--gray-6);
  border-radius: 5px;
}
.Amenu::-webkit-scrollbar-thumb:active {
  background: var(--gray-8);
  border-radius: 5px;
}

.Amenu {
  width: 240px;
  height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: transparent;
  border: none;
}
.Amenu::v-deep .ant-menu-submenu > .ant-menu {
  border: none;
  background-color: transparent;
}
.Amenu::v-deep .ant-menu-item:not(.ant-menu-item-disabled):hover,
.Amenu::v-deep .ant-menu-item:not(.ant-menu-item-disabled):focus,
.Amenu::v-deep .ant-menu-item:not(.ant-menu-item-disabled):active,
.Amenu::v-deep .ant-menu-item-active:not(.ant-menu-item-disabled),
.Amenu::v-deep .ant-menu-submenu-title:active {
  background-color: var(--theme-light);
  color: var(--theme-color);
}
.Amenu::v-deep .ant-menu-item-selected {
  border: none;
  background-color: var(--theme-light);
  border-radius: 4px;
  color: var(--theme-color);
}
.Amenu::v-deep .ant-menu-submenu-selected,
.ant-menu-submenu-active,
.ant-menu-item-active {
  color: var(--theme-color);
}
.Amenu::v-deep .ant-menu-submenu-title:hover {
  color: var(--theme-color);
}
.Amenu::v-deep .ant-menu-item-selected::after {
  border: none;
}

.ListBox {
  padding-left: 1rem;
  padding-bottom: 2rem;
  cursor: pointer;
  position: relative;
}
.ListBox .title {
  font-weight: 500;
  color: var(--text-title);
}
.disable {
  color: var(--text-placeholder);
}

.breadcrumbBox {
  padding: 1rem;
}
.breadcrumbBox::v-deep .ant-breadcrumb > span:last-child {
  color: var(--text-secondary);
}
</style>
